import { createAsyncThunk } from '@reduxjs/toolkit';

import OneSpanSignApi from 'api/curo/OneSpanSignApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createGetSigningUrlThunk = (api: OneSpanSignApi) =>
  createAsyncThunk(ApplicationProcessActionTypes.GetSigningUrl, async () => {
    const response = await api.getSigningUrl();

    return response;
  });
